export default "skymp5-front/6696c58666d1bdb9c8965ed5784bc978.mp3";